export const ENGINE_IMAGE_SRC_45_ANGLE =
  'https://assets.isuzu-tis.com/22_ddi_maxforce_biturbo_45darken_b55da9ab97.png';

export const ENGINE_LOGO_SRC =
  'https://assets.isuzu-tis.com/22_ddi_biturbo_vector_53007e350a.svg';
